module.exports = __webpack_public_path__ + "officialStatic/fonts/RWmMoKWR9v4ksMfaWd_JN9XFiaQ.2458d50.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/RWmMoKWR9v4ksMfaWd_JN9XFiaQ.woff2
// module id = OlEv
// module chunks = 0